import posthog from 'posthog-js';

import { basePostHogClientOptions } from '@bazak/analytics/client';

import { DEPLOY_ENV, POSTHOG_ENABLED, POSTHOG_HOST } from '@/common/constants';

let initialized = false;

function initPostHog() {
  if (initialized || !process.env.NEXT_PUBLIC_POSTHOG_KEY) return;
  initialized = true;
  posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
    ...basePostHogClientOptions({ host: POSTHOG_HOST }),
    // Logs each browser agent's call to our WebMCP tools, with the model it reports. Not `intent`:
    // that adds a required free-text input to every tool, and an agent's text there can carry the
    // personal details a tool like scanBrand takes, which posthog would store as `$mcp_intent`.
    capture_webmcp: { intent: false },
  });

  // Super-property — applies to every subsequent event from the SDK.
  posthog.register({ environment: DEPLOY_ENV });
}

if (POSTHOG_ENABLED && typeof window !== 'undefined') {
  initPostHog();
}
